export default __webpack_public_path__ + "static/DSC01738-0891c140173a3b33b93d56a676e63a2e.jpg";